<template>
  <div
    class="form-group searchSelect"
    :class="{
      'has-error': errors[title] != undefined,
      focused: (modelValue != '' && modelValue != null) || open ? true : false,
      open: open,
    }"
    v-clickOutside="close"
  >
    <Field
      v-maska="maska"
      v-bind="$attrs"
      :id="uid"
      :name="title"
      class="form-control"
      :class="{ 'parsley-error': errors[title] != undefined }"
      v-model="setText"
      :rules="rules"
      @focus="open = true"
    />
    <label class="control-label" :for="uid">{{ title }} </label>
    <div class="drop" v-if="data != null" v-show="open">
      <input
        type="text"
        v-model="search"
        placeholder="Search..."
        class="form-control"
        ref="search"
      />
      <ul>
        <template v-for="item in data" :key="item.value">
          <li
            @click="
              $emit('update:modelValue', item.value);
              $emit('change', item.value);
              open = false;
              search = '';
            "
            :class="{ active: item.value == modelValue }"
            v-if="item.text.toLowerCase().indexOf(search.toLowerCase()) > -1"
          >
            {{ item.text }}
          </li>
        </template>
        <li class="noData">No Data</li>
      </ul>
    </div>
  </div>
</template>

<script>
// import searchSelectBox from "./searchSelectBox.vue";
export default {
  name: "searchSelect",
  props: {
    data: null,
    title: null,
    modelValue: null,
    errors: {
      default: {},
    },
    rules: {
      default: {},
    },
  },
  data() {
    return {
      uid: this.$uniqueid(),
      search: "",
      open: false,
    };
  },
  watch: {
    open() {
      if (this.open) {
        let timer = setInterval(() => {
          if (this.$refs.search != undefined) {
            this.$refs.search.focus();
            clearInterval(timer);
          }
        }, 1);
      }
    },
  },
  methods: {
    close() {
      this.open = false;
    },
  },
  computed: {
    setText() {
      return this.data.filter((x) => x.value == this.modelValue).length > 0
        ? this.data.filter((x) => x.value == this.modelValue)[0].text
        : "";
    },
  },
};
</script>

<style scoped></style>
